import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Sidebar from './components/Sidebar';
// import Dashboard from './pages/Dashboard';
import EngCompsts from './pages/Eng_compsts'; 
import EnergyClubMonthly from './pages/EnergyClubMonthly'; 
import EnergyClubPending from './pages/EnergyClubPending';
import EngPendingByName from './pages/Eng_pending_byname';
import FundsStatus from './pages/FundsStatus';
import UserActivityStatus from './pages/UserActivityStatus';
import Monthly_performance from './pages/Monthly_performance';
import ActivityNotSubmitted from './pages/ActivityNotSubmitted';
import ViewSchools from './pages/ViewSchools';
import CustomProgramMonitor from './pages/CustomProgramMonitor';
import CustomProgramNotSubmited from './pages/CustomProgramNotSubmited';
import ViewCustomSchool from './pages/ViewCustomSchool';
import View_not_custom_list from './pages/View_not_custom_list';
import FundDetails from "./pages/FundDetails";
import FundAlocation from "./pages/FundAlocation";
import FundUtilisation from "./pages/FundUtilisationDashboard";

function App() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      {/* Header */}
      <Header />

      {/* Main layout */}
      <div style={{ display: 'flex', flex: 1 }}>
        {/* Sidebar */}
        <Sidebar />

        {/* Main content */}
        <main style={{ flex: 1, padding: '20px', overflowY: 'auto' }}>
          <Routes>
            {/* <Route path="/" element={<Dashboard />} /> */}
            <Route path="/" element={<Monthly_performance />} />
            <Route path="/ActivityNotSubmitted" element={<ActivityNotSubmitted />} />
            <Route path="/eng-compsts" element={<EngCompsts />} />
            <Route path="/eng-monthly" element={<EnergyClubMonthly />} />
            <Route path="/energy-club-pending" element={<EnergyClubPending />} />
            <Route path="/view-schools" element={<ViewSchools />} />
            <Route path="/eng-pending-byname" element={<EngPendingByName />} />
            <Route path="/funds-status" element={<FundsStatus />} />
            <Route path="/user-activity-status" element={<UserActivityStatus />} />
            <Route path="/CustomProgramMonitor" element={<CustomProgramMonitor />} />
            <Route path="/CustomProgramNotSubmited" element={<CustomProgramNotSubmited />} />
            <Route path="/view-custom-school" element={<ViewCustomSchool />} />
            <Route path="/View_not_custom_list" element={<View_not_custom_list />} />
            <Route path="/fund-details" element={<FundDetails />} />
            <Route path="/FundAlocation" element={<FundAlocation />} />
            <Route path="/fund-utilisation-details" element={<FundUtilisation />} />
          </Routes>

        </main>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default App;
